import styled from "styled-components";

export const TableActionMenuStyled = styled.div`
  .action-menu {
    .def-background {
      border-radius: 4px;
      border: solid 1px #301d35;
      background: #e6d8e9;
    }
    .menu-icon {
      height: 32px;
      width: 32px;
      margin-left: 0px;
      .MuiSvgIcon-root {
        height: 20px;
        width: 20px;
      }
      &.menu-opened {
        border-radius: 4px;
        border: solid 2px #b9bec7;
        background: #301d35;

        .MuiSvgIcon-root {
          color: white;
        }
      }
      &.disabled {
        opacity: 0.3;
      }
    }
  }
`;
